import type { FC } from "react";
import type { IconCommonProps } from "@/icons/shared.ts";

export const IconClock: FC<IconCommonProps> = ({ width, height, color }) => {
  return (
    <svg
      width={width ?? 15}
      height={height ?? 15}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.33167 3.33171V7.33171L8.99834 9.99837M13.9983 7.33171C13.9983 11.0136 11.0136 13.9984 7.33167 13.9984C3.64978 13.9984 0.665009 11.0136 0.665009 7.33171C0.665009 3.64981 3.64978 0.665039 7.33167 0.665039C11.0136 0.665039 13.9983 3.64981 13.9983 7.33171Z"
        stroke={color ?? "#050038"}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
